import React, { Children } from 'react';
import { Row } from 'components/row/Row';

import s from './ImageList.scss';

interface IProps {
  children: React.ReactNode;
  title?: string;
  isColumnLayout?: boolean;
}

export const ImageList = ({ children, title, isColumnLayout }: IProps) => {

  if (!children) {
    return null;
  }
  
  return (
    <div className={s('imageList', { isColumnLayout })}>
      {title && <h2 className={s.imageList__heading}>{title}</h2>}
      <Row>
        {Children.map(children, (child, i) =>
          <div className={s.imageList__item} key={i}>{child}</div>
        )}
      </Row>
    </div>
  );
};

